import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';
import { ProjectDeadlineExtensionsEdit } from 'features/Project/pages/ProjectDeadlineExtensions/pages';

function ProjectDeadlineExtensionsEditPage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <ProjectDeadlineExtensionsEdit />
      </Layout>
    </LayoutProvider>
  );
}

export default ProjectDeadlineExtensionsEditPage;
